import { UserInfo } from "os";
import { UserModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";
export class UserRepo extends BaseDataRepository<UserModel> {
  protected baseUrl = 'User';

  async getRefreshUserInfo() :Promise<any>{
    const response = await this.client.get(`${this.baseUrl}/getupdateduserinfo`)
    return this.handleResponse<any>(response)!
  }

}

export default UserRepo;